<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("distributor", 1) }} {{ $t("contract") }}
      </div>
      <div>
        <a
          class="btn-blue"
          v-if="$can('update', 'Distributor Contract')"
          @click.prevent.stop="
            goToRoute('/distributor/edit-distributor-contract')
          "
          >{{ $t("edit") }}</a
        >
        <router-link class="btn-blue" to="distributor-contract"
          >{{ $tc("distributor", 1) }} {{ $t("contract") }}
          {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("cinema", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ selecedCinema }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("movie", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{
                  distributorContracts.md_id_list &&
                  distributorContracts.md_id_list.length > 0
                    ? distributorContracts.md_id_list
                    : ""
                }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("distributor", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ selectedDistributor }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("weekwiseContract", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ selectedContract }}
              </div>
            </div>
          </div>

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3">
                <div>{{ $t('share') }} {{ $tc('type', 1) }}</div>
              </div>

              <div class="col-md-3">
                <div>{{ $t('value') }}</div>
              </div>

              <div class="col-md-3 mb-2">
                <div>{{ $t('fromdate') }}</div>
              </div>

              <div class="col-md-3 mb-2">
                <div>{{ $t('enddate') }}</div>
              </div>

              <div class="col-md-3">
                <div
                  v-for="(distributorWeeklyContract, distributorWeeklyContractIndex) in distributorWeeklyContracts"
                  :key="distributorWeeklyContractIndex"
                >
                  <div class="mb-1">{{ distributorWeeklyContract.dst_label }}</div>
                </div>
              </div>

              <div class="col-md-3">
                <div
                  v-for="(distributorWeeklyContract, distributorWeeklyContractIndex) in distributorWeeklyContracts"
                  :key="distributorWeeklyContractIndex"
                >
                  <div class="mb-1">{{ distributorWeeklyContract.dcd_share_value }}</div>
                </div>
              </div>

              <div class="col-md-3">
                <div
                  v-for="(distributorWeeklyContract, distributorWeeklyContractIndex) in distributorWeeklyContracts"
                  :key="distributorWeeklyContractIndex"
                >
                  <div class="mb-1">{{ distributorWeeklyContract.dcd_from_date | dateparse }}</div>
                </div>
              </div>

              <div class="col-md-3">
                <div
                  v-for="(distributorWeeklyContract, distributorWeeklyContractIndex) in distributorWeeklyContracts"
                  :key="distributorWeeklyContractIndex"
                >
                  <div class="mb-1">{{ distributorWeeklyContract.dcd_to_date | dateparse }}</div>
                </div>
              </div>
            </div>
          </div> -->

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{
                  distributorContracts.dc_is_active == "Y" ? $t("active") : ""
                }}
              </div>
            </div>
          </div>

          <div
            class="col-md-12 py-2 border-bottom"
            v-if="login_user_role_id === 1"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ distributorContracts.created_by_by }}</span>
              </div>
            </div>
          </div>

          <div
            class="col-md-12 py-2 border-bottom"
            v-if="login_user_role_id === 1"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{
                  distributorContracts["created_at_at"] | dateparse
                }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div
            class="col-md-12 py-2 border-bottom"
            v-if="login_user_role_id === 1"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ distributorContracts.updated_by_by }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2" v-if="login_user_role_id === 1">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{
                  distributorContracts.updated_at_at | dateparse
                }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      login_user_role_id: null,
      // Saif
      Cinemas: [],
      Movies: [],
      Distributors: [],
      DistributorShareTypes: [],
      distributorContracts: {
        cinema_id: null,
        md_id: null,
        md_id_list: [],
        distributor_id: null,
        dc_id: null,
        dc_is_active: "Y",
        updated_by_by: "",
        updated_at_at: "",
        created_at_at: "",
        created_by_by: "",
      },
      distributorWeeklyContracts: [
        {
          dcd_from_date: null,
          dcd_to_date: null,
          dcd_from_date_timestamp: "",
          dcd_to_date_timestamp: "",
          distributor_share_type_id: null,
          selectedDistributorShareType: "",
          dcd_share_value: 0,
        },
      ],
      selecedCinema: "",
      selectedMovie: "",
      selectedDistributor: "",
      selectedContract: "",
      selectedDistributorShareType: "",

      // Saif

      checked: "y",
      selectedNewDate: "",
      selecedCinema: "",
      selectedMovie: "",
      selectedDistributor: "",
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    // console.log("this.$route.query :", this.$route.query);
    if (id) {
      this.getDistributorDetails(id);
    } else {
      this.$router.go(-1);
    }

    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    // Saif
    getDistributorDetails(dc_id) {
      DistributorService.GetDistributorContractById({ dc_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.distributorContracts = data.Records[0];
            // this.distributorWeeklyContracts =
            //   data.Records[0].DistributorWeeklyContracts;

            this.getViewUsersDetails(
              obj["created_by_by"],
              "created_by_by",
              "distributorContracts"
            );
            this.getViewUsersDetails(
              obj["updated_by_by"],
              "updated_by_by",
              "distributorContracts"
            );
            this.distributorContracts.updated_at_at =
              obj["updated_at_at"] || "";
            this.distributorContracts.created_at_at =
              obj["created_at_at"] || "";

            this.getCinemaList(obj.cine_id);
            this.getMoviesList(obj.md_id);
            this.getDistributorsList(obj.distributor_id);
            this.getWeekWiseContractList(this.distributorContracts.cbw_id);
            // this.distributorWeeklyContracts = [];
            // data.Records[0].DistributorWeeklyContracts.map(x => {
            //   this.distributorWeeklyContracts.push({
            //     ...x,
            //     dcd_from_date: new Date(x.dcd_from_date),
            //     dcd_to_date: new Date(x.dcd_to_date),
            //     selectedDistributorShareType: x.dst_label
            //   });
            // });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getCinemaList: function (cine_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (cine_id === x.cine_id) {
                this.selecedCinema = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getMoviesList: function (md_id_list) {
      MovieService.GetActiveMoviesWithFormat()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Movies = data.Records;
            // let array = md_id_list.split(",");
            // this.distributorContracts.md_id_list = [];
            this.Movies.map((x) => {
              // let temp = array.filter(y => String(y) === String(x.md_id));
              // if (temp.length > 0) {
              if (md_id_list === x.md_id) {
                this.distributorContracts.md_id_list = x.movie;
              }
            });
            // this.distributorContracts.md_id_list = this.distributorContracts.md_id_list
            //   .map(x => x.movie)
            //   .toString();
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getDistributorsList: function (distributor_id) {
      DistributorService.GetActiveDistributors({ activekey: "d_is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Distributors = data.Records;
            this.Distributors.map((x) => {
              if (String(distributor_id) === String(x.d_id)) {
                this.selectedDistributor = x.d_company_name;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getWeekWiseContractList: function (contract_id) {
      DistributorService.GetAllWeekWiseContractList()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Contracts = data.Records;
            this.Contracts.map((x) => {
              if (String(x.cbw_id) === String(contract_id)) {
                this.selectedContract = x.contract_weekwise_name;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: {
          id: this.distributorContracts.dc_id,
        },
      });
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch(this._CatchError);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorContractComponents/viewDistributorContract.vue